import React, { useState } from 'react';
import { Flex, Text, Heading, Button, Image } from '@chakra-ui/core';
import TextInput from '../shared/TextInput';
import theme, { colors } from '@styles/theme-chakra';
import { HIVE_API } from '@lib/platform';
import { motion } from 'framer-motion';

import Star from '@assets/Star';
import StarFilled from '@assets/StarFilled';
import ArrowButton from '@assets/arrowbutton.png';
import ArrowButtonDisabled from '@assets/arrowbutton_disabled.png';

const query = `
  mutation createReview($input: CreateReviewInput!) {
    createReview(input: $input) {
      ok
    }
  }
`;

const Rating = () => {
  const [score, setScore] = useState(0);
  const [note, setNote] = useState('');
  const [saved, setSaved] = useState(false);

  const onSubmit = async e => {
    if (e) e.preventDefault();
    let url = '';
    if (typeof window !== 'undefined') url = window.location.href;
    try {
      await fetch(HIVE_API, {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          variables: {
            input: { score, notes: note, url }
          },
          operationName: 'createReview',
          query: query
        })
      });
    } catch (e) {
      console.log(e);
    }
    setSaved(true);
  };

  return (
    <Flex
      mt={10}
      direction="column"
      backgroundColor={colors.iceberg}
      px={8}
      py={8}
      borderRadius="8px"
    >
      <Heading
        as="h4"
        fontWeight={theme.fontWeights.semibold}
        fontSize={theme.fontSizes[3]}
      >
        Did you enjoy this article?
      </Heading>
      {saved ? (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        >
          <Flex>
            <Text fontSize={theme.fontSizes[2]}>
              We hear you loud and clear! Thanks for the feedback.
            </Text>
          </Flex>
        </motion.div>
      ) : (
        <>
          <Flex>
            {[1, 2, 3, 4, 5].map(i => {
              const onClick = () => {
                setScore(i);
              };
              if (score >= i) {
                return (
                  <span style={{ cursor: 'pointer' }} key={`star-${i}`} onClick={onClick}>
                    <StarFilled />
                  </span>
                );
              } else {
                return (
                  <span style={{ cursor: 'pointer' }} key={`star-${i}`} onClick={onClick}>
                    <Star onClick={onClick} />
                  </span>
                );
              }
            })}
          </Flex>
          <Flex alignItems="center" mt={4}>
            <Flex width={['75%', '20rem']}>
              <TextInput
                mt={0}
                onChange={setNote}
                onKeyUp={e => {
                  if (e.key === 'Enter' && score !== 0) {
                    onSubmit();
                  }
                }}
                placeholder="Your Feedback"
              />
            </Flex>
            <Flex pl={6} justify="center" align="center">
              <Flex as="button" onClick={onSubmit} disabled={score === 0}>
                <Image
                  height="3rem"
                  width="3rem"
                  src={score === 0 ? ArrowButtonDisabled : ArrowButton}
                />
              </Flex>
            </Flex>
          </Flex>
        </>
      )}
    </Flex>
  );
};

export default Rating;
